import { use, useMemo } from 'react';

import { DropdownContexts } from 'component-library/components/Input/Dropdown/context/DropdownContext';
import { type UserPickerDropdownItem } from '../types';
import { UserListItem } from './UserListItem';
import { ListWrapper } from './styles';

type UserListProps = {
  maxSelections?: number;
};

export const UserList = ({ maxSelections }: UserListProps) => {
  const { items } = use(DropdownContexts.useItems);
  const { searchActive, searchResults } = use(DropdownContexts.useSearch);
  const { selectedValues } = use(DropdownContexts.props);

  const itemsToRender = useMemo(
    () =>
      (searchActive ? searchResults : items).filter(
        (item): item is UserPickerDropdownItem => item.meta !== undefined,
      ),
    [searchActive, searchResults, items],
  );

  const selectedCount = selectedValues.length;

  return (
    <ListWrapper>
      {itemsToRender.map((item) => (
        <UserListItem
          key={item.value}
          item={item}
          maxSelections={maxSelections}
          selectedCount={selectedCount}
        />
      ))}
    </ListWrapper>
  );
};
